export default __webpack_public_path__ + "static/media/electrician_worker.8872c14c.png";